import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { ChecklistRepository } from '../../../infrastructure/repositories/checklist.repository';
import { ChecklistListState } from '../../states/checklist-list.state';
import { DeleteChecklistResult } from './delete-checklist.result';

@Injectable({ providedIn: 'root' })
export class DeleteChecklistUseCase {
  private readonly _repository = inject(ChecklistRepository);
  private readonly _state = inject(ChecklistListState);

  public execute(caseTypeId: string): Observable<DeleteChecklistResult> {
    this._state.setSaving(true);
    this._state.clearError();

    return this._repository.deleteChecklist(caseTypeId).pipe(
      tap(() => {
        this._state.removeChecklist(caseTypeId);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setError(error?.error?.message || error?.message || 'Failed to delete checklist');
        throw error;
      }),
      finalize(() => {
        this._state.setSaving(false);
      }),
    );
  }
}
